import { useTranslation } from 'react-i18next';

import { FileList, Label } from 'coreOld/elements';
import { IFile } from 'coreOld/types';

import { DropzoneContainer, Message, Wrapper } from './fileDropzoneStyle';
import { DropzoneInputProps, DropzoneRootProps } from 'react-dropzone';

interface IProps {
  files?: IFile[];
  onRemoveFile?: (file: IFile) => void;
  getRootProps: <T extends DropzoneRootProps>(props?: T) => T;
  getInputProps: <T extends DropzoneInputProps>(props?: T) => T;
  isDragActive?: boolean;
  isDragAccept?: boolean;
  isDragReject?: boolean;
}

const FileDropzoneView = ({
  files,
  onRemoveFile,
  getRootProps,
  getInputProps,
  isDragActive,
  isDragAccept,
  isDragReject,
}: IProps) => {
  const { t } = useTranslation();

  return (
    <Wrapper>
      <Label label={t('labelUploadFile')} />

      <DropzoneContainer
        {...getRootProps()}
        isDragActive={isDragActive}
        isDragAccept={isDragAccept}
        isDragReject={isDragReject}
      >
        <input {...getInputProps()} />

        <Message>
          {isDragActive && isDragAccept && <p>{t('messageDropFilesZone')}</p>}

          {!isDragActive && <p>{t('messageDragAndDropFiles')}</p>}

          {isDragReject && <p>{t('errorInvalidFileType')}</p>}
        </Message>
      </DropzoneContainer>

      <FileList files={files} removeFile={onRemoveFile} />
    </Wrapper>
  );
};

export default FileDropzoneView;
